/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
    document.addEventListener("DOMContentLoaded", (event) => {
        var links = document.links;
        for (let i = 0, linksLength = links.length; i < linksLength; i++) {
            if (links[i].hostname !== window.location.hostname) {
                links[i].target = "_blank";
                links[i].rel = "noreferrer noopener";
            }
        }


        //Avatar for blog posts
        const avatar = document.querySelector('.article-info__author-avatar');
        if (!avatar) return;
        const newImageUrl = avatar.dataset.author;
        if (!newImageUrl) return;
        const newImage = new Image();
        newImage.onload = function () {
            avatar.src = newImageUrl;
        };
        newImage.onerror = function () {
            // image doesn't exist → нічого не робимо
            console.log('Author image not found');
        };
        newImage.src = newImageUrl;
    });






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('click', function(event) {
  const button = event.target.closest('.boost-card-add-to-cart[data-add-to-cart]');

  if (!button) return;

  const form = button.closest('form');
  const errorContainer = form?.querySelector('[data-cart-errors-container]');

  if (!form || button.disabled) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  button.classList.add('is-loading');
  button.disabled = true;

  if (errorContainer) {
    errorContainer.textContent = '';
    errorContainer.classList.remove('is-expanded');
  }

  fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json'
    },
    body: new FormData(form)
  })
    .then(function(response) {
      return response.json();
    })
    .then(function(response) {
      if (response.status) {
        throw response;
      }

      const cart = document.querySelector('cart-element');

      if (cart && typeof cart.getCart === 'function') {
        cart.button = button;
        cart.getCart();
      } else {
        window.location.href = window.theme?.routes?.cart_url || '/cart';
      }
    })
    .catch(function(error) {
      const message = error?.description || error?.message || 'Unable to add this item to the cart.';

      button.classList.remove('is-loading');
      button.disabled = false;

      if (errorContainer) {
        errorContainer.textContent = message;
        errorContainer.classList.add('is-expanded');
      }
    });
}, true);


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("img").forEach(function (img) {
    const alt = img.getAttribute("alt");

    // If alt is missing or empty
    if (!alt || alt.trim() === "") {
      const src = img.getAttribute("src");
      if (!src) return;

      // Extract filename from URL
      let filename = src.split("/").pop().split("?")[0];

      // Remove file extension
      filename = filename.replace(/\.[^/.]+$/, "");

      // Make it more readable: replace dashes/underscores with spaces
      filename = filename.replace(/[-_]+/g, " ").trim();

      if (filename) {
        img.setAttribute("alt", filename);
      }
    }
  });

      const observer = new MutationObserver(() => {
        const img = document.querySelector('img[src*="bat.bing.com"]');

        if (img) {
            img.setAttribute('alt', 'tracker')
            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

function checkCartMinimum() {
  const drawer = document.getElementById('cart-drawer');
  const notice = document.getElementById('cart-minimum-notice');
  const priceElement = document.querySelector('[data-cart-total-price]');

  if (drawer && notice && priceElement) {
    const isDrawerVisible = drawer.classList.contains('is-open');
    const currentTotal = parseFloat(priceElement.textContent.replace(/[^\d.]/g, ''));

    if (isDrawerVisible && currentTotal > 0 && currentTotal < 300) {
      notice.style.display = 'block';
    } else {
      notice.style.display = 'none';
    }
  }
}

function setAnchorTarget() {
  const links = document.querySelectorAll('a');
  links.forEach(link => {
    let href = link.getAttribute('href');
    if (href && href.includes('anchor')) {
      let id = href.split('#')[1];
      let anchorClass = '.' + id;
      let anchorElement = document.querySelector(anchorClass);
      if (anchorElement) {
        let section = anchorElement.closest('section');
        link.addEventListener('click', function (e) {
          e.preventDefault();
          section.scrollIntoView({ behavior: 'smooth' });
        });
      }
    }
  });
}

const cartNoticeObserver = new MutationObserver(checkCartMinimum);

cartNoticeObserver.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class', 'style']
});

document.addEventListener('DOMContentLoaded', checkCartMinimum);
window.addEventListener('load', checkCartMinimum);


function scrollToConfiguredTarget(trigger) {
  const configuredTarget = trigger.dataset.scrollTarget?.trim();
  let targetSelector = configuredTarget;
  let target;

  if (configuredTarget?.toLowerCase().startsWith('anchor:')) {
    const anchor = configuredTarget.slice(configuredTarget.indexOf(':') + 1).trim();
    if (!anchor) return false;

    target = Array.from(document.querySelectorAll('[data-scroll-anchor]')).find(function(element) {
      return element.dataset.scrollAnchor?.toLowerCase() === anchor.toLowerCase();
    });
  }

  if (!target) {
    try {
      target = targetSelector ? document.querySelector(targetSelector) : null;
    } catch (error) {
      return false;
    }
  }

  if (!target) return false;

  const sectionTarget = target.hasAttribute('data-scroll-anchor')
    ? target.closest('.shopify-section') || target
    : target;

  const offsetValue = window.matchMedia('(max-width: 767px)').matches
    ? trigger.dataset.scrollOffsetMobile
    : trigger.dataset.scrollOffset;
  const offset = Number.parseInt(offsetValue, 10) || 0;
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const originalScrollMarginTop = sectionTarget.style.scrollMarginTop;
  const focusTarget = sectionTarget.matches('h1, h2, h3, h4, h5, h6, [role="heading"]')
    ? sectionTarget
    : sectionTarget.querySelector('h1, h2, h3, h4, h5, h6, [role="heading"]') || sectionTarget;
  const hadTabindex = focusTarget.hasAttribute('tabindex');

  sectionTarget.style.scrollMarginTop = `${-offset}px`;
  sectionTarget.scrollIntoView({ behavior: behavior, block: 'start', inline: 'nearest' });

  if (!hadTabindex) {
    focusTarget.setAttribute('tabindex', '-1');
  }

  focusTarget.focus({ preventScroll: true });

  if (!hadTabindex) {
    focusTarget.addEventListener('blur', function() {
      focusTarget.removeAttribute('tabindex');
    }, { once: true });
  }

  window.setTimeout(function() {
    sectionTarget.style.scrollMarginTop = originalScrollMarginTop;
  }, behavior === 'smooth' ? 1000 : 0);

  return true;
}

window.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-smooth-scroll]');

  if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  scrollToConfiguredTarget(trigger);
}, true);

window.addEventListener('keydown', function(event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;

  const trigger = event.target.closest('[data-smooth-scroll]');
  if (!trigger || trigger.matches('a[href]')) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  scrollToConfiguredTarget(trigger);
}, true);
(function() {
  const selector = '.boost-sd__instant-search-results--two-column.boost-sd__instant-search-results--product-type-grid .boost-sd__suggestion-queries-item-img';
  const desktopSizes = '(min-width: 991px) 220px, 50vw';

  function getImages(root) {
    if (!root) return [];
    if (root.matches && root.matches(selector)) return [root];
    if (root.querySelectorAll) return Array.from(root.querySelectorAll(selector));
    return [];
  }

  function upgradeImageSrc(img) {
    const src = img.getAttribute('src');
    if (!src) return;

    try {
      const url = new URL(src, window.location.origin);
      const width = Number(url.searchParams.get('width'));

      if (url.hostname.includes('cdn.shopify.com') && width > 0 && width < 500) {
        url.searchParams.set('width', '500');
        img.setAttribute('src', url.toString());
      }
    } catch (error) {
      // Leave non-standard image URLs alone.
    }
  }

  function upgradeBoostInstantSearchImages(root) {
    getImages(root).forEach(function(img) {
      if (img.dataset.boostInstantSearchImageUpgraded === 'true') return;

      img.setAttribute('sizes', desktopSizes);

      const srcset = img.getAttribute('srcset');
      if (srcset) {
        img.setAttribute('srcset', '');
        img.setAttribute('srcset', srcset);
      }

      upgradeImageSrc(img);
      img.dataset.boostInstantSearchImageUpgraded = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    upgradeBoostInstantSearchImages(document);

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          upgradeBoostInstantSearchImages(node);
        });
      });
    });

    observer.observe(document.body, {childList: true, subtree: true});
  });
})();

(function() {
  const inputSelector = '.boost-sd__search-widget-init-input';
  const resultsSelector = '.boost-sd__instant-search-results';
  const otherResultsSelector = '.boost-sd__instant-search-column--others';
  const groupSelector = '.boost-sd__suggestion-queries-group';
  const pageHeaderSelector = '.boost-sd__suggestion-queries-header--pages';
  const cache = new Map();
  let requestId = 0;
  let syncTimer;

  function getActiveInput() {
    if (document.activeElement && document.activeElement.matches(inputSelector)) return document.activeElement;
    return document.querySelector(inputSelector + '[aria-expanded="true"]');
  }

  function getResults(input) {
    const controls = input && input.getAttribute('aria-controls');
    const wrapper = controls && document.getElementById(controls);
    return (wrapper && wrapper.querySelector(resultsSelector)) || document.querySelector(resultsSelector);
  }

  function createCollectionGroup(results) {
    const otherResults = results.querySelector(otherResultsSelector);
    if (!otherResults) return null;

    const group = document.createElement('div');
    group.className = 'boost-sd__suggestion-queries-group';

    const header = document.createElement('h3');
    header.tabIndex = 0;
    header.setAttribute('role', 'text');
    header.className = 'boost-sd__header-item boost-sd__suggestion-queries-header boost-sd__suggestion-queries-header--pages';

    const list = document.createElement('ul');
    list.className = 'boost-sd__suggestion-queries-list';

    group.append(header, list);
    otherResults.append(group);
    return group;
  }

  function renderProductCollections(results, collections) {
    const productColumn = results.querySelector('.boost-sd__instant-search-column--products');
    const viewAll = productColumn && productColumn.querySelector('.boost-sd__view-all');
    if (!productColumn || !viewAll) return;

    const existing = productColumn.querySelector('.boost-sd__related-collections');
    if (existing) existing.remove();

    const relatedCollections = document.createElement('div');
    relatedCollections.className = 'boost-sd__related-collections';

    const label = document.createElement('p');
    label.className = 'boost-sd__related-collections-label';
    label.textContent = 'Related collections';

    const list = document.createElement('ul');
    list.className = 'boost-sd__related-collections-list';
    list.setAttribute('aria-label', 'Related collections');

    collections.forEach(function(collection) {
      const item = document.createElement('li');
      item.className = 'boost-sd__related-collections-item';

      const link = document.createElement('a');
      link.className = 'boost-sd__related-collections-link';
      link.href = collection.url;
      link.textContent = collection.title;

      item.append(link);
      list.append(item);
    });

    relatedCollections.append(label, list);
    productColumn.insertBefore(relatedCollections, viewAll);
  }

  function renderCollections(input, searchTerm, collections) {
    if (input.value.trim() !== searchTerm) return;

    const results = getResults(input);
    if (!results) return;

    if (!collections.length) {
      const relatedCollections = results.querySelector('.boost-sd__related-collections');
      if (relatedCollections) relatedCollections.remove();
      delete results.dataset.collectionSearchTerm;
      return;
    }

    const pageHeader = results.querySelector(pageHeaderSelector);
    if (
      results.dataset.collectionSearchTerm === searchTerm &&
      pageHeader &&
      pageHeader.textContent.trim() === 'Collections' &&
      results.querySelector('.boost-sd__related-collections')
    ) return;
    const group = (pageHeader && pageHeader.closest(groupSelector)) || createCollectionGroup(results);
    if (!group) return;

    const header = group.querySelector('.boost-sd__suggestion-queries-header');
    const list = group.querySelector('.boost-sd__suggestion-queries-list');
    if (!header || !list) return;

    header.textContent = 'Collections';
    list.setAttribute('aria-label', 'Collection list');
    list.replaceChildren();

    collections.forEach(function(collection) {
      const item = document.createElement('li');
      item.className = 'boost-sd__suggestion-queries-item boost-sd__suggestion-queries-item--mobile-style1';
      item.dataset.extraParam = 'false';
      item.dataset.title = collection.title;

      const link = document.createElement('a');
      link.className = 'boost-sd__suggestion-queries-link';
      link.href = collection.url;
      link.setAttribute('aria-label', 'Collection: ' + collection.title);

      const title = document.createElement('span');
      title.setAttribute('aria-hidden', 'true');
      title.textContent = collection.title;

      link.append(title);
      item.append(link);
      list.append(item);
    });

    renderProductCollections(results, collections);
    results.dataset.collectionSearchTerm = searchTerm;
  }

  function requestCollections(input) {
    if (!input) return;

    const searchTerm = input.value.trim();
    if (!searchTerm) return;

    if (cache.has(searchTerm)) {
      renderCollections(input, searchTerm, cache.get(searchTerm));
      return;
    }

    const currentRequestId = ++requestId;
    const url = new URL(window.theme.routes.predictiveSearchUrl, window.location.origin);
    url.searchParams.set('q', searchTerm);
    url.searchParams.set('resources[type]', 'collection');
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('section_id', 'api-predictive-search');

    fetch(url.toString())
      .then(function(response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function(html) {
        if (currentRequestId !== requestId || input.value.trim() !== searchTerm) return;

        const responseDocument = new DOMParser().parseFromString(html, 'text/html');
        const collectionGroup = responseDocument.querySelector(
          '.predictive-search__group[aria-labelledby="predictiveSearchSecondaryResults"]'
        );
        const collectionTitles = new Set();
        const collections = collectionGroup
          ? Array.from(collectionGroup.querySelectorAll('.predictive-search__item a'))
              .map(function(link) {
                return {title: link.textContent.trim(), url: link.getAttribute('href')};
              })
              .filter(function(collection) {
                const title = collection.title.toLowerCase();
                if (collectionTitles.has(title)) return false;
                collectionTitles.add(title);
                return true;
              })
              .slice(0, 3)
          : [];

        cache.set(searchTerm, collections);
        renderCollections(input, searchTerm, collections);
      })
      .catch(function() {
        // Keep Booster's page suggestions as the fallback when collections cannot be loaded.
      });
  }

  function scheduleSync(input) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function() {
      requestCollections(input || getActiveInput());
    }, 100);
  }

  document.addEventListener('input', function(event) {
    if (event.target.matches(inputSelector)) scheduleSync(event.target);
  });

  document.addEventListener('DOMContentLoaded', function() {
    const observer = new MutationObserver(function(mutations) {
      const hasBoostResultsChange = mutations.some(function(mutation) {
        if (mutation.target.closest && mutation.target.closest(resultsSelector)) return true;

        return Array.from(mutation.addedNodes).some(function(node) {
          return node.nodeType === 1 &&
            (node.matches(resultsSelector) || node.querySelector(resultsSelector));
        });
      });

      if (hasBoostResultsChange) scheduleSync();
    });

    observer.observe(document.body, {childList: true, subtree: true});
  });
})();

(function() {
  function updateClearButton(input) {
    const inputHolder = input.closest('.search-form__input-holder');
    const clearButton = inputHolder && inputHolder.querySelector('[data-search-clear]');
    if (clearButton) clearButton.hidden = input.value.length === 0;
  }

  function updateViewAllCount(predictiveSearch) {
    const count = predictiveSearch.dataset.searchResultsCount;
    if (!count) return;

    predictiveSearch.querySelectorAll('[data-predictive-search-view-all]').forEach(function(link) {
      const label = link.dataset.labelTemplate.replace('[count]', count);
      const labelElement = link.querySelector('[data-predictive-search-view-all-label]');

      if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
      if (labelElement && labelElement.textContent !== label) labelElement.textContent = label;
    });
  }

  function requestFullSearchCount(input) {
    const searchTerm = input.value.trim();
    const predictiveSearch = input.closest('predictive-search');
    if (!predictiveSearch) return;

    if (!searchTerm) {
      delete predictiveSearch.dataset.searchResultsCount;
      return;
    }

    clearTimeout(input.fullSearchCountTimer);
    input.fullSearchCountTimer = setTimeout(function() {
      const boostShopDomain = window.boostWidgetIntegration?.config?.shop?.domain;
      const url = boostShopDomain
        ? new URL('https://services.mybcapps.com/bc-sf-filter/search')
        : new URL(window.theme.routes.searchUrl, window.location.origin);

      url.searchParams.set('q', searchTerm);
      if (boostShopDomain) {
        url.searchParams.set('shop', boostShopDomain);
        url.searchParams.set('limit', '1');
      } else {
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('section_id', 'api-search-count');
      }

      fetch(url.toString())
        .then(function(response) {
          if (!response.ok) throw new Error(response.status);
          return boostShopDomain ? response.json() : response.text();
        })
        .then(function(response) {
          if (input.value.trim() !== searchTerm) return;

          const count = boostShopDomain
            ? response.total_product
            : new DOMParser().parseFromString(response, 'text/html').querySelector('[data-search-results-count]')?.textContent.trim();
          if (count === undefined || count === null || count === '') return;

          predictiveSearch.dataset.searchResultsCount = count;
          updateViewAllCount(predictiveSearch);
        })
        .catch(function() {
          // Keep the predictive-search count as the fallback if the count request fails.
        });
    }, 350);
  }

  function ensureHeaderPredictiveSearch(input) {
    const predictiveSearch = input.closest('search-popdown[data-popdown-in-header] predictive-search');
    if (!predictiveSearch || !input.value.trim()) return;

    clearTimeout(input.predictiveSearchFallbackTimer);
    input.predictiveSearchFallbackTimer = setTimeout(function() {
      if (predictiveSearch.hasAttribute('loading') || predictiveSearch.hasAttribute('results')) return;

      // Boost Search can intercept input events on the search-results template.
      // Start the theme's native predictive search only when its own handler did not.
      if (typeof predictiveSearch.onChange === 'function') predictiveSearch.onChange();
    }, 400);
  }

  function closeOpenHeaderMenus() {
    document.querySelectorAll('[data-site-header] hover-disclosure.is-visible').forEach(function(disclosure) {
      if (typeof disclosure.hideDisclosure === 'function') disclosure.hideDisclosure();
    });
  }

  function closePredictiveSearchOnOutsidePointer(event) {
    document.querySelectorAll('predictive-search[open="true"]').forEach(function(predictiveSearch) {
      if (predictiveSearch.contains(event.target)) return;

      if (typeof predictiveSearch.close === 'function') predictiveSearch.close();
      predictiveSearch.removeAttribute('open');
      predictiveSearch.removeAttribute('loading');

      const input = predictiveSearch.querySelector('input[type="search"]');
      if (input) {
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      }

      const searchPopdown = predictiveSearch.closest('search-popdown[data-popdown-in-header]');
      if (searchPopdown && typeof searchPopdown.close === 'function') searchPopdown.close();
    });
  }

  document.addEventListener('input', function(event) {
    if (!event.target.matches('input[type="search"]')) return;

    updateClearButton(event.target);
    requestFullSearchCount(event.target);
  });

  document.addEventListener('input', function(event) {
    if (!event.target.matches('input[type="search"]')) return;

    ensureHeaderPredictiveSearch(event.target);
  }, true);

  document.addEventListener('focusin', function(event) {
    if (!event.target.matches('input[type="search"]')) return;

    ensureHeaderPredictiveSearch(event.target);
  }, true);

  document.addEventListener('click', function(event) {
    const clearButton = event.target.closest('[data-search-clear]');
    if (!clearButton) return;

    const search = clearButton.closest('search-popdown');
    const input = search && search.querySelector('input[type="search"]');
    if (!input) return;

    event.preventDefault();
    input.value = '';
    input.dispatchEvent(new Event('input', {bubbles: true}));
    input.focus();
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest('search-popdown[data-popdown-in-header] [data-popdown-toggle]')) return;

    closeOpenHeaderMenus();
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.search-form__input-holder input[type="search"]').forEach(updateClearButton);

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          const predictiveSearch = node.parentElement && node.parentElement.closest('predictive-search');
          if (predictiveSearch) updateViewAllCount(predictiveSearch);
        });
      });
    });

    observer.observe(document.body, {childList: true, subtree: true});
  });

  document.addEventListener('pointerdown', closePredictiveSearchOnOutsidePointer, true);
})();

(function() {
  const paginationSelector = '.boost-sd__pagination button';
  const activePageSelector = '.boost-sd__pagination-number--active';
  const toolbarSelector = '.boost-sd__toolbar-container';

  function getRequestedPage(button) {
    const label = button.getAttribute('aria-label') || '';
    const pageMatch = label.match(/^Go to Page (\d+)$/);

    if (pageMatch) return Number(pageMatch[1]);

    const currentPage = document.querySelector(activePageSelector);
    const currentPageNumber = currentPage ? Number(currentPage.textContent.trim()) : 0;

    if (!currentPageNumber) return 0;
    if (button.classList.contains('boost-sd__pagination-button--next')) return currentPageNumber + 1;
    if (button.classList.contains('boost-sd__pagination-button--prev')) return currentPageNumber - 1;

    return 0;
  }

  function scrollToCollectionGrid() {
    const toolbar = document.querySelector(toolbarSelector);
    if (!toolbar) return;

    const stickyHeader = document.querySelector('[data-site-header][data-position="fixed"]');
    const headerOffset = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
    const top = toolbar.getBoundingClientRect().top + window.scrollY - headerOffset - 16;

    window.scrollTo({ top: Math.max(0, top), left: 0, behavior: 'auto' });
  }

  document.addEventListener('click', function(event) {
    const button = event.target.closest(paginationSelector);
    if (!button || button.classList.contains('boost-sd__pagination-number--active')) return;

    const requestedPage = getRequestedPage(button);
    if (!requestedPage) return;

    const observer = new MutationObserver(function() {
      const activePage = document.querySelector(activePageSelector);

      if (!activePage || Number(activePage.textContent.trim()) !== requestedPage) return;

      observer.disconnect();
      requestAnimationFrame(function() {
        requestAnimationFrame(scrollToCollectionGrid);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function() { observer.disconnect(); }, 5000);
  }, true);
})();

(function() {
  const configSelector = '[data-search-results-enhancements]';
  const productListSelector = '.boost-sd__product-list';
  const productSelector = ':scope > .boost-sd__product-item';
  const emptyResultSelector = '.boost-sd__no-search-result-page-empty';
  const stopWords = new Set(['and', 'for', 'the', 'with']);
  const designModeCollections = [
    {title: 'Roller Chains', url: '/collections/all'},
    {title: 'Sprockets', url: '/collections/all'},
    {title: 'Conveyor Components', url: '/collections/all'},
    {title: 'Industrial Parts', url: '/collections/all'}
  ];

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function getRelevantCollections(collections, searchTerm) {
    const normalizedQuery = normalize(searchTerm);
    const queryTokens = normalizedQuery.split(' ').filter(function(token) {
      return token.length > 1 && !stopWords.has(token);
    });
    const seenTitles = new Set();

    if (!queryTokens.length) return [];

    return collections
      .map(function(collection, index) {
        const normalizedTitle = normalize(collection.title);
        const titleTokens = new Set(normalizedTitle.split(' '));
        const matches = queryTokens.filter(function(token) { return titleTokens.has(token); }).length;
        const coverage = matches / queryTokens.length;
        const phraseMatch = normalizedTitle.includes(normalizedQuery);
        const qualifies = queryTokens.length === 1
          ? queryTokens[0].length >= 3 && titleTokens.has(queryTokens[0])
          : phraseMatch || matches === queryTokens.length || (queryTokens.length >= 3 && coverage >= 0.67);

        return {collection: collection, index: index, coverage: coverage, phraseMatch: phraseMatch, qualifies: qualifies};
      })
      .filter(function(result) {
        if (!result.qualifies) return false;
        const title = normalize(result.collection.title);
        if (seenTitles.has(title)) return false;
        seenTitles.add(title);
        return true;
      })
      .sort(function(a, b) {
        if (a.phraseMatch !== b.phraseMatch) return a.phraseMatch ? -1 : 1;
        if (a.coverage !== b.coverage) return b.coverage - a.coverage;
        return a.index - b.index;
      })
      .slice(0, 4)
      .map(function(result) { return result.collection; });
  }

  function createCollectionCard(collection, collectionLabel) {
    const item = document.createElement('li');
    item.className = 'search-results-collections__item';

    const link = document.createElement('a');
    link.className = 'search-results-collections__link';
    link.href = collection.url;
    link.setAttribute('aria-label', collectionLabel + ': ' + collection.title);

    const media = document.createElement('span');
    media.className = 'search-results-collections__media';
    media.setAttribute('aria-hidden', 'true');

    if (collection.featured_image && collection.featured_image.url) {
      const image = document.createElement('img');
      image.className = 'search-results-collections__image';
      image.src = collection.featured_image.url;
      image.alt = '';
      image.loading = 'lazy';
      media.append(image);
    } else {
      const monogram = document.createElement('span');
      monogram.className = 'search-results-collections__monogram';
      monogram.textContent = collection.title.charAt(0);
      media.append(monogram);
    }

    const title = document.createElement('span');
    title.className = 'search-results-collections__title';
    title.textContent = collection.title;

    const arrow = document.createElement('span');
    arrow.className = 'search-results-collections__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';

    link.append(media, title, arrow);
    item.append(link);
    return item;
  }

  function renderCollections(config, collections) {
    const app = config.closest('[data-collection-apps]');
    if (!app) return;

    const existing = app.querySelector('[data-search-results-collections]');
    if (existing) existing.remove();
    if (!collections.length) return;

    const section = document.createElement('section');
    section.className = 'search-results-collections';
    section.dataset.searchResultsCollections = '';

    const heading = document.createElement('h2');
    heading.className = 'search-results-collections__heading';
    heading.textContent = config.dataset.collectionsLabel;

    const list = document.createElement('ul');
    list.className = 'search-results-collections__list';
    collections.forEach(function(collection) {
      list.append(createCollectionCard(collection, config.dataset.collectionLabel));
    });

    section.append(heading, list);

    const header = app.querySelector('.boost-sd__search-form-wrapper');
    const position = config.dataset.collectionsPosition === 'above' ? 'beforebegin' : 'afterend';
    if (header) header.insertAdjacentElement(position, section);
    else config.insertAdjacentElement('afterend', section);
  }

  function syncSearchEmptyState(config) {
    const app = config.closest('[data-collection-apps]');
    if (!app) return;

    const header = app.querySelector('.boost-sd__search-form-wrapper');
    if (!header) return;

    const title = header.querySelector('.boost-sd__search-form-title');
    const emptyResults = app.querySelector('.boost-sd-right.boost-sd-no-search-result');
    const sourceMessage = emptyResults?.querySelector(emptyResultSelector);
    const headerMessage = header.querySelector('.search-results-empty-message');
    const message = sourceMessage || headerMessage;
    const hasNoResults = Boolean(emptyResults && message);

    app.classList.toggle('has-search-empty-results', hasNoResults);
    if (title) title.hidden = hasNoResults;

    if (hasNoResults) {
      const customMessage = config.querySelector('[data-no-results-message-template]')?.innerHTML.trim() || '';
      const searchTerm = config.dataset.searchTerm.trim();
      const messageSignature = customMessage + '\u0000' + searchTerm;

      if (customMessage && message.dataset.customMessageSignature !== messageSignature) {
        const richText = document.createElement('template');
        richText.innerHTML = customMessage;
        const textNodes = [];
        const textNodeWalker = document.createTreeWalker(richText.content, NodeFilter.SHOW_TEXT);

        while (textNodeWalker.nextNode()) textNodes.push(textNodeWalker.currentNode);

        textNodes.forEach(function(textNode) {
          if (!textNode.nodeValue.includes('[query]')) return;

          const replacement = document.createDocumentFragment();
          const messageParts = textNode.nodeValue.split('[query]');

          messageParts.forEach(function(part, index) {
            replacement.append(document.createTextNode(part));

            if (index < messageParts.length - 1) {
              const highlightedQuery = document.createElement('span');
              highlightedQuery.className = 'boost-sd__no-search-result-page-search-result';
              highlightedQuery.textContent = searchTerm;
              replacement.append(highlightedQuery);
            }
          });

          textNode.replaceWith(replacement);
        });

        message.replaceChildren(richText.content.cloneNode(true));
        message.dataset.customMessageSignature = messageSignature;
      }

      if (!message.searchResultsPlaceholder && message.parentNode !== header) {
        message.searchResultsPlaceholder = document.createComment('search empty message');
        message.parentNode.insertBefore(message.searchResultsPlaceholder, message);
      }

      message.classList.add('search-results-empty-message');
      const form = header.querySelector('.boost-sd__search-form');
      if (message.parentNode !== header) header.insertBefore(message, form || null);
      return;
    }

    if (!headerMessage) return;
    const placeholder = headerMessage.searchResultsPlaceholder;
    headerMessage.classList.remove('search-results-empty-message');

    if (placeholder?.parentNode) {
      placeholder.parentNode.insertBefore(headerMessage, placeholder);
      placeholder.remove();
      headerMessage.searchResultsPlaceholder = null;
    } else {
      headerMessage.remove();
    }
  }

  function loadCollections(config) {
    const searchTerm = config.dataset.searchTerm.trim();
    if (!searchTerm) {
      if (window.Shopify?.designMode) renderCollections(config, designModeCollections);
      return;
    }
    if (config.dataset.collectionsRequested === 'true') return;
    config.dataset.collectionsRequested = 'true';

    const url = new URL(window.theme.routes.predictiveSearchUrl, window.location.origin);
    url.pathname = url.pathname.replace(/\/?$/, '.json');
    url.searchParams.set('q', searchTerm);
    url.searchParams.set('resources[type]', 'collection');
    url.searchParams.set('resources[limit]', '10');

    fetch(url.toString())
      .then(function(response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function(response) {
        const collections = response.resources?.results?.collections || [];
        renderCollections(config, getRelevantCollections(collections, searchTerm));
      })
      .catch(function() {
        config.dataset.collectionsRequested = 'false';
      });
  }

  function getProductPrice(product) {
    try {
      const productData = JSON.parse(product.dataset.product || '{}');
      const price = Number(productData.priceMin ?? productData.price_min);
      if (Number.isFinite(price)) return price;
    } catch (error) {
      // Fall back to Booster's rendered price markup.
    }

    const priceText = product.querySelector('.boost-sd__product-price-content')?.textContent.trim() || '';
    const numericPrice = Number(priceText.replace(/[^0-9.]/g, ''));
    return Number.isFinite(numericPrice) ? numericPrice : 0;
  }

  function prioritizePricedProducts(root) {
    root.querySelectorAll(productListSelector).forEach(function(list) {
      const products = Array.from(list.querySelectorAll(productSelector));
      if (products.length < 2) return;

      const orderedProducts = products
        .map(function(product, index) {
          return {product: product, index: index, hasPrice: getProductPrice(product) > 0};
        })
        .sort(function(a, b) {
          if (a.hasPrice !== b.hasPrice) return a.hasPrice ? -1 : 1;
          return a.index - b.index;
        });

      const signature = orderedProducts.map(function(item) {
        return (item.product.dataset.productId || item.product.id || item.index) + ':' + Number(item.hasPrice);
      }).join('|');

      if (list.dataset.pricePrioritySignature === signature) return;
      orderedProducts.forEach(function(item) { list.append(item.product); });
      list.dataset.pricePrioritySignature = signature;
    });
  }

  function initializeSearchResults(config) {
    if (!config) return;
    if (config.dataset.searchResultsInitialized === 'true') return;
    config.dataset.searchResultsInitialized = 'true';

    loadCollections(config);
    prioritizePricedProducts(document);
    syncSearchEmptyState(config);

    const observer = new MutationObserver(function(mutations) {
      const hasRelevantChange = mutations.some(function(mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.target.matches?.('.boost-sd-right, .boost-sd__search-form-wrapper')
        ) return true;

        return Array.from(mutation.addedNodes).some(function(node) {
          return node.nodeType === 1 && (
            node.matches?.('.boost-sd__search-form-wrapper, ' + productListSelector + ', .boost-sd__product-item, .boost-sd-right, ' + emptyResultSelector) ||
            node.querySelector?.('.boost-sd__search-form-wrapper, ' + productListSelector + ', .boost-sd__product-item, .boost-sd-right, ' + emptyResultSelector)
          );
        });
      });

      if (!hasRelevantChange) return;
      const collectionsSection = config.closest('[data-collection-apps]')?.querySelector('[data-search-results-collections]');
      const header = config.closest('[data-collection-apps]')?.querySelector('.boost-sd__search-form-wrapper');
      const position = config.dataset.collectionsPosition === 'above' ? 'beforebegin' : 'afterend';
      const isInCorrectPosition = collectionsSection && header && (
        position === 'afterend'
          ? collectionsSection.previousElementSibling === header
          : collectionsSection.nextElementSibling === header
      );
      if (collectionsSection && header && !isInCorrectPosition) {
        header.insertAdjacentElement(position, collectionsSection);
      }
      prioritizePricedProducts(document);
      syncSearchEmptyState(config);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function initializeSearchResultsSections() {
    document.querySelectorAll(configSelector).forEach(initializeSearchResults);
  }

  document.addEventListener('DOMContentLoaded', initializeSearchResultsSections);
  document.addEventListener('shopify:section:load', initializeSearchResultsSections);
})();

document.addEventListener('DOMContentLoaded', setAnchorTarget);
